import firebase from "@/firebase";

const defaultState = {
  address: "",
  city: "",
  country: "",
  email: "",
  firstName: "",
  lastName: "",
  premium: false,
  state: "",
  type: "",
  uid: "",
};

let userInitPromise;

const userStore = {
  namespaced: true,
  state: { ...defaultState },
  getters: {
    getUser(state) {
      return state;
    },
  },
  mutations: {
    setUser(state, user) {
      state.address = user.address || state.address;
      state.city = user.city || state.city;
      state.country = user.country || state.country;
      state.postalCode = user.postalCode || state.postalCode;
      state.email = user.email || state.email;
      state.firstName = user.firstName || state.firstName;
      state.lastName = user.lastName || state.lastName;
      state.newsletterSubscribed =
        user.newsletterSubscribed || state.newsletterSubscribed;
      state.premium = user.premium || state.premium;
      state.state = user.state || state.state;
      state.type = user.type || state.type;
      state.uid = user.uid || state.uid;
    },
    clearUser(state) {
      Object.assign(state, defaultState);
    },
  },
  actions: {
    async initUser(state) {
      if (!firebase.auth.currentUser) {
        state.commit("clearUser");
        userInitPromise = Promise.resolve();
        return;
      }
      userInitPromise = (async () => {
        const doc = await firebase.db
          .collection("users")
          .doc(firebase.auth.currentUser.uid)
          .get();
        const userData = doc.data();
        state.commit("setUser", userData);
      })();
      await userInitPromise;
    },
    async login(state, data) {
      try {
        const user = (
          await firebase.auth.signInWithEmailAndPassword(
            data.email,
            data.password
          )
        ).user;
        const doc = await firebase.db.collection("users").doc(user.uid).get();
        const userData = doc.data();
        state.commit("setUser", userData);
      } catch (err) {
        throw err;
      }
    },
    async recoverPassword(state, email) {
      try {
        await firebase.auth.sendPasswordResetEmail(email);
      } catch (err) {
        throw err;
      }
    },
    async register(state, data) {
      try {
        const user = (
          await firebase.auth.createUserWithEmailAndPassword(
            data.email,
            data.password
          )
        ).user;
        await firebase.db.collection("users").doc(user.uid).set({
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          type: data.type,
          uid: user.uid,
          country: data.country,
          postalCode: data.postalCode,
          newsletterSubscribed: data.newsletterSubscribed,
        });
        state.commit("setUser", data);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    async saveUser(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db.collection("users").doc(state.state.uid).update(data);
      state.commit("setUser", data);
    },
  },
};

export function awaitUserInit() {
  if (!userInitPromise) {
    return import("@/store").then((mod) => {
      mod.default.dispatch("user/initUser");
      return userInitPromise;
    });
  }
  return userInitPromise;
}

export default userStore;
